<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content m-0">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.contactUploadCsv.title' | translate }}</h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="onClose()"
        ></button>
      </div>

      <span class="alert alert-info m-1 fw-semibold fs-6" role="alert">
        <i class="mdi mdi-information-outline"></i>
        {{ 'shared.contactUploadCsv.infoBanner' | translate }}
        <a
          class="text-primary text-decoration-underline"
          href="assets/csv/importacao_modelo_contato.csv"
          download="importacao_modelo_contato.csv"
          >{{ 'shared.contactUploadCsv.clickHere' | translate }}</a
        >
      </span>

      <ul class="nav nav-tabs nav-bordered" role="tablist">
        <li class="nav-item" role="presentation">
          <a
            class="nav-link active"
            id="import-contacts-tab"
            data-bs-toggle="tab"
            data-bs-target="#import-contacts"
            type="button"
            role="tab"
            aria-controls="import-contacts"
            aria-selected="true"
          >
            <i
              class="mdi mdi-cloud-download-outline download-icon d-md-none d-block"
            ></i>
            <span class="d-none d-md-inline">{{ 'shared.contactUploadCsv.title' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            id="rules-tab"
            data-bs-toggle="tab"
            data-bs-target="#rules"
            type="button"
            role="tab"
            aria-controls="rules"
            aria-selected="false"
          >
            <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
            <span class="d-none d-md-inline">{{ 'shared.contactUploadCsv.rulesTab' | translate }}</span>
          </a>
        </li>
      </ul>

      <div class="tab-content card-body" id="tabComponentsContent">
        <div
          class="tab-pane fade show active custom-scroll-bar card-upload-csv overflow-x-hidden"
          id="import-contacts"
          role="tabpanel"
          aria-labelledby="import-contacts-tab"
        >
          <div class="col-xs-12">
            <div class="row">
              <div class="p-3">
                <div class="row justify-content-center mb-4">
                  <div class="col-10">
                    <div class="horizontal-steps">
                      <div class="horizontal-steps-content">
                        <div
                          class="step-item"
                          [class.current]="stepIndex === 0"
                        >
                          <span>{{ 'shared.contactUploadCsv.stepLoad' | translate }}</span>
                        </div>
                        <div
                          class="step-item"
                          [class.current]="stepIndex === 1"
                        >
                          <span>{{ 'shared.contactUploadCsv.stepMap' | translate }}</span>
                        </div>
                        <div
                          class="step-item"
                          [class.current]="stepIndex === 2"
                        >
                          <span>{{ 'shared.contactUploadCsv.stepPreview' | translate }}</span>
                        </div>
                      </div>
                      <div
                        class="process-line"
                        [style.width]="(stepIndex / 2) * 100 + '%'"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="">
                  @switch (stepIndex) {
                    @case (0) {
                      <div class="row mt-2">
                        <div class="rounded-3 p-3">
                          <label
                            for="dropzone-file"
                            class="dz-area w-100"
                            role="button"
                            [attr.aria-label]="'shared.contactUploadCsv.dropzoneAriaLabel' | translate"
                          >
                            <div class="dz-inner text-center">
                              <i
                                class="mdi mdi-cloud-upload-outline mb-2 upload-icon text-muted"
                              ></i>
                              <div class="fw-semibold fs-5 text-secondary mb-1">
                                {{ 'shared.contactUploadCsv.clickToUpload' | translate }}
                              </div>
                              <small class="text-muted"
                                >{{ 'shared.contactUploadCsv.onlyCsvFiles' | translate }}</small
                              >
                            </div>
                          </label>

                          <input
                            id="dropzone-file"
                            type="file"
                            class="d-none"
                            accept=".csv"
                            (change)="handleFileSelect($event)"
                            #inputFile
                          />

                          @if (fileLoaded) {
                            <div
                              class="alert alert-info d-flex align-items-center justify-content-between gap-2 mt-3"
                              role="alert"
                            >
                              <div
                                class="d-flex align-items-center gap-2 text-dark fw-semibold"
                              >
                                <i
                                  class="mdi mdi-file-check-outline text-2rem"
                                ></i>

                                <div class="d-flex flex-column">
                                  <span>{{ filename }}</span>
                                  <span class="small text-muted">
                                    {{ fileSizeMb }}</span
                                  >
                                </div>
                              </div>

                              <div>
                                <i
                                  class="mdi mdi-trash-can-outline text-danger"
                                  role="button"
                                  (click)="clearFile()"
                                ></i>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @case (1) {
                      <div class="step-card mt-4">
                        <div class="table-responsive mt-4">
                          <table class="table table-centered mb-3">
                            <thead>
                              <tr>
                                <th>{{ 'shared.contactUploadCsv.fileColumn' | translate }}</th>
                                <th>{{ 'shared.contactUploadCsv.preview' | translate }}</th>
                                <th>{{ 'shared.contactUploadCsv.targetField' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (map of mappings; track $index) {
                                <tr>
                                  <td>{{ map.csvColumn }}</td>
                                  <td>{{ map.sample }}</td>
                                  <td>
                                    <mat-select
                                      class="form-control"
                                      [value]="map.mappedTo"
                                      (selectionChange)="
                                        applyMappingByColumn(
                                          map.csvColumn,
                                          $event.value
                                        )
                                      "
                                    >
                                      <mat-option value="phone"
                                        >{{ 'shared.contactUploadCsv.fieldPhone' | translate }}</mat-option
                                      >
                                      <mat-option value="name">{{ 'shared.contactUploadCsv.fieldName' | translate }}</mat-option>
                                      <mat-option value="email"
                                        >{{ 'shared.contactUploadCsv.fieldEmail' | translate }}</mat-option
                                      >
                                      <mat-option value="tags"
                                        >{{ 'shared.contactUploadCsv.fieldTags' | translate }}</mat-option
                                      >
                                      <mat-option value="ignore"
                                        >{{ 'shared.contactUploadCsv.fieldIgnore' | translate }}</mat-option
                                      >
                                    </mat-select>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                    @case (2) {
                      @if (csvContent.length) {
                        <div class="step-card mt-4">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div class="mb-3">
                              <label class="form-label"
                                >{{ 'shared.contactUploadCsv.totalContacts' | translate }}</label
                              >
                              <h5 class="fw-semibold text-center">
                                {{ csvContent.length }}
                              </h5>
                            </div>
                            <div class="mb-3">
                              <label class="form-label"
                                >{{ 'shared.contactUploadCsv.contactsWithoutError' | translate }}</label
                              >
                              <h5 class="fw-semibold text-center text-success">
                                {{
                                  csvContent.length - getNumberContactErrors()
                                }}
                              </h5>
                            </div>
                            <div class="mb-3">
                              <label class="form-label"
                                >{{ 'shared.contactUploadCsv.contactsWithError' | translate }}</label
                              >
                              <h5
                                class="fw-semibold text-center text-danger"
                                (click)="filterOnlyErrors()"
                                style="cursor: pointer; text-decoration: underline;"
                                [matTooltip]="'shared.contactUploadCsv.filterErrorsTooltip' | translate"
                              >
                                {{ getNumberContactErrors() }}
                              </h5>
                              @if (getNumberContactErrors() > 0) {
                                <div class="mb-3 d-flex align-items-end">
                                  <button
                                    class="btn btn-sm btn-outline-danger"
                                    type="button"
                                    [matTooltip]="'shared.contactUploadCsv.removeErrorsTooltip' | translate"
                                    (click)="removeAllErrors()"
                                  >
                                    <i
                                      class="mdi mdi-delete-sweep-outline me-1"
                                    ></i>
                                    {{ 'shared.contactUploadCsv.removeAllErrors' | translate }}
                                  </button>
                                </div>
                              }
                            </div>
                          </div>

                          <div class="table-responsive">
                            <table
                              class="table table-hover table-centered mb-0"
                            >
                              <thead>
                                <tr>
                                  <th class="text-primary-emphasis">{{ 'shared.contactUploadCsv.fieldName' | translate }}</th>
                                  <th class="text-primary-emphasis">
                                    {{ 'shared.contactUploadCsv.fieldPhone' | translate }}
                                  </th>
                                  <th class="text-primary-emphasis">{{ 'shared.contactUploadCsv.fieldEmail' | translate }}</th>
                                  <th class="text-primary-emphasis">
                                    {{ 'shared.contactUploadCsv.fieldTags' | translate }}
                                  </th>
                                  <th class="sr-only"></th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (row of paginatedContent; track row) {
                                  <tr role="row">
                                    <td>
                                      <span
                                        [ngClass]="{
                                          'text-danger': row['hasError'],
                                          'text-dark': !row['hasError'],
                                        }"
                                      >
                                        {{ row["name"] }}
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        [ngClass]="{
                                          'text-danger': row['hasError'],
                                          'text-dark': !row['hasError'],
                                        }"
                                      >
                                        {{ row["phone"] }}
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        [ngClass]="{
                                          'text-danger': row['hasError'],
                                          'text-dark': !row['hasError'],
                                        }"
                                      >
                                        {{ row["email"] }}
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        [ngClass]="{
                                          'text-danger': row['hasError'],
                                          'text-dark': !row['hasError'],
                                        }"
                                      >
                                        {{ row["tags"] }}
                                      </span>
                                    </td>
                                    <td
                                      class="py-3 pl-3 pr-4 text-right text-sm"
                                    >
                                      <div role="none">
                                        <a
                                          href="javascript:void(0)"
                                          class="text-danger text-decoration-none"
                                          role="menuitem"
                                          (click)="delete(row)"
                                        >
                                          <i
                                            class="mdi mdi-trash-can-outline"
                                          ></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr class=""></tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <mat-paginator
                          [length]="csvContent.length"
                          [pageSize]="pageSize"
                          (page)="handlePage($event)"
                        ></mat-paginator>
                      }
                    }
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-2">
            <div class="col-12 gap-2 d-flex justify-content-end pb-4">
              <button class="btn btn-outline-secondary" (click)="onClose()">
                {{ 'shared.contactUploadCsv.cancel' | translate }}
              </button>

              @if (stepIndex > 0) {
                <button class="btn btn-dark" (click)="prev()">{{ 'shared.contactUploadCsv.back' | translate }}</button>
              }

              @if (stepIndex === 0) {
                <button
                  class="btn btn-primary"
                  (click)="onContinueFromStep1()"
                  [disabled]="!fileLoaded || loading"
                >
                  {{ 'shared.contactUploadCsv.continue' | translate }}
                </button>
              } @else if (stepIndex === 1) {
                <button
                  class="btn btn-primary"
                  (click)="onContinueFromStep2()"
                  [disabled]="!isMappingValid()"
                >
                  {{ 'shared.contactUploadCsv.continue' | translate }}
                </button>
              } @else if (stepIndex === 2) {
                <button
                  class="btn btn-primary"
                  type="submit"
                  (click)="save()"
                  [disabled]="
                    loading ||
                    !csvContent.length ||
                    getNumberContactErrors() > 0
                  "
                >
                  @if (loading) {
                    <mat-spinner
                      [diameter]="15"
                      [color]="'accent'"
                      mode="indeterminate"
                    />
                  } @else {
                    {{ 'shared.contactUploadCsv.import' | translate }}
                  }
                </button>
              }
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="rules"
          role="tabpanel"
          aria-labelledby="rules-tab"
        >
          <div class="col-xs-12 overflow-x-hidden">
            <div class="row">
              <div class="p-3">
                <div class="mb-3 custom-scroll-bar card-rules">
                  <div class="mt-3">
                    <p class="mb-3">
                      {{ 'shared.contactUploadCsv.rulesIntro' | translate }}
                    </p>

                    <p class="fw-bold mb-1">
                      {{ 'shared.contactUploadCsv.rulesSection1Title' | translate }}
                    </p>
                    <ul class="list-circle ps-4 mb-3">
                      <li>{{ 'shared.contactUploadCsv.rulesSection1Item1' | translate }}</li>
                      <li [innerHTML]="'shared.contactUploadCsv.rulesSection1Item2' | translate"></li>
                      <li [innerHTML]="'shared.contactUploadCsv.rulesSection1Item3' | translate"></li>
                    </ul>

                    <p class="fw-bold mb-1">
                      {{ 'shared.contactUploadCsv.rulesSection2Title' | translate }}
                    </p>
                    <ul class="list-circle ps-4 mb-3">
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection2Item1' | translate }}
                      </li>
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection2Item2' | translate }}
                      </li>
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection2Item3' | translate }}
                      </li>
                    </ul>

                    <p class="fw-bold mb-1">
                      {{ 'shared.contactUploadCsv.rulesSection3Title' | translate }}
                    </p>
                    <ul class="list-circle ps-4 mb-3">
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection3Item1' | translate }}
                      </li>
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection3Item2' | translate }}
                      </li>
                      <li [innerHTML]="'shared.contactUploadCsv.rulesSection3Item3' | translate"></li>
                    </ul>

                    <p class="fw-bold mb-1">{{ 'shared.contactUploadCsv.rulesSection4Title' | translate }}</p>
                    <ul class="list-circle ps-4 mb-3">
                      <li [innerHTML]="'shared.contactUploadCsv.rulesSection4Item1' | translate"></li>
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection4Item2' | translate }}
                      </li>
                      <li>
                        {{ 'shared.contactUploadCsv.rulesSection4Item3' | translate }}
                      </li>
                      <li>{{ 'shared.contactUploadCsv.rulesSection4Item4' | translate }}</li>
                      <li>{{ 'shared.contactUploadCsv.rulesSection4Item5' | translate }}</li>
                    </ul>

                    <p class="mb-0">
                      {{ 'shared.contactUploadCsv.rulesOutro' | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
